export default function APP_VERSION() {
  return (
    <div style={{ marginTop: 30 }}>
      <center>
        <span style={{ color: "#777" }}>v:{__APP_VERSION__}</span>
      </center>
    </div>
  );
}
